import appStore from 'store';
import api from './api';
import { STATUS_TYPES, PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {
    projectList: state =>
      state.auditList.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.auditStatus]
      }))
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setpage(state, page) {
      state.pagination = page;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getAuditList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    setPass(context, data) {
      return api.setPass(data);
    },
    exportExcel({commit},data){
      return   api.exportExcel(data).then(res=>{
             return res
         })
     },
  }
};

appStore.registerModule('deposite', store);
